import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RAZORPAY_CONFIG, loadRazorpay } from '../../config/razorpay';

interface Props {
  amount: number;
  email: string;
  name: string;
  productName: string;
}

declare global {
  interface Window {
    Razorpay: any;
  }
}

export const PaymentButton = ({ amount, email, name, productName }: Props) => {
  const navigate = useNavigate();

  const handlePayment = async () => {
    const isLoaded = await loadRazorpay();
    if (!isLoaded) {
      alert('Razorpay SDK failed to load');
      return;
    }

    const options = {
      key: RAZORPAY_CONFIG.key_id,
      amount: amount * 100, // Convert to paise
      currency: RAZORPAY_CONFIG.currency,
      name: RAZORPAY_CONFIG.name,
      description: productName,
      prefill: {
        name,
        email,
      },
      handler: (response: any) => {
        // Handle successful payment
        console.log('Payment successful:', response);
        navigate('/payment-success', {
          state: {
            paymentId: response.razorpay_payment_id,
            amount,
            productName,
          },
        });
      },
      modal: {
        ondismiss: () => {
          navigate('/payment-failed');
        },
      },
      theme: {
        color: '#1E293B',
      },
    };

    try {
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error('Razorpay error:', error);
      alert('Payment initialization failed. Please try again.');
    }
  };

  return (
    <button
      onClick={handlePayment}
      className="w-full btn"
      type="button"
    >
      Pay ₹{amount.toFixed(2)}
    </button>
  );
};